// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"styles_contentWrapper___2Qm13","content":"styles_content___2AG4L"};